(function ($) {
  $(document).ready(function () {
    var popupSelector = '.js-open-add-to-cart-content-section-popup';

    $(popupSelector).on('click', function (e) {
      const productId = $(this).data('product-id');

      if (!productId) {
        return;
      }

      var refresh =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?add_to_cart_product_id=' +
        productId;
      window.history.pushState({ path: refresh }, '', refresh);
    });

    window.addEventListener('elementor/popup/show', function (e) {
      var instance = e.detail.instance;

      // Check if there is add to cart section widget in popup
      if (
        $(instance.$element).find(
          '[data-widget_type="Dnaera_Add_To_Cart_Content_Section.default"]'
        ).length < 1
      ) {
        return;
      }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (!urlParams.has('add_to_cart_product_id')) {
        return;
      }

      const productId = parseInt(urlParams.get('add_to_cart_product_id'));

      if (!productId) {
        return;
      }

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: woocommerce_params.ajax_url,
        data: { action: 'get_discounts_html', product_id: productId },
        success: function (response) {
          $('.js-product-quantity-discounts-wrap').html(response);

          dnaEraAddToCartContentSectionInit();

          // Check first checkbox
          const firstRadioInput = jQuery(
            '.js-add-to-cart-content-section-radio-input'
          ).first();

          if (firstRadioInput.length > 0) {
            firstRadioInput.prop('checked', true);
            const event = new Event('change');
            firstRadioInput.get(0).dispatchEvent(event);
          }
        },
      });
    });
  });
})(jQuery);
